import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { icpApi } from '@/lib/api';
import { toast } from '@solid/ui';
import type { IcpProfile } from '@/types';

export function useIcp() {
  return useQuery<IcpProfile>({
    queryKey: ['icp'],
    queryFn: () => icpApi.get(),
  });
}

export function useUpdateIcp() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof icpApi.update>[1] }) =>
      icpApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['icp'] });
      toast.success('Ideal Customer Profile has been saved.');
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || 'Failed to update ICP.');
    },
  });
}
